export const PASSTHROUGH_LIST = [
	{
		label: 'YES',
		name: 'passThrough',
		value: 1,
		isDisabled: false
	},
	{
		label: 'NO',
		name: 'passThrough',
		value: 0,
		isDisabled: false
	},
];
